module.exports = __webpack_public_path__ + "media/assets/img/flags/mn-MN-023f34bfe2bbf8c1b860b62c3860698c.png";